<template>
  <v-dialog
    v-model="visible"
    class="org-modal"
    scrollable
    max-width="500"
  >
    <v-card
      v-if="action === 'delete'"
      class="pa-6"
    >
      <v-card-title primary-title>
        <div class="headline darkestblue--text">
          Are you sure?
        </div>
        <v-card-actions>
          <v-btn
            :ripple="false"
            icon
            @click.stop="close()"
          >
            <v-icon color="brightblue">
              close
            </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card-title>

      <v-card-text>
        <div class="coolgray--text">
          <v-row>
            <v-col :class="`subtitle-2 font-weight-bold ${titleColor}--text`">
              Client ID
            </v-col>
            <v-col class="body-1">
              {{ entry.clientId }}
            </v-col>
          </v-row>

          <v-row>
            <v-col :class="`subtitle-2 font-weight-bold ${titleColor}--text`">
              Name
            </v-col>
            <v-col class="body-1">
              {{ entry.clientName }}
            </v-col>
          </v-row>

          <v-row>
            <v-col :class="`subtitle-2 font-weight-bold ${titleColor}--text`">
              Billing Code
            </v-col>
            <v-col class="body-1">
              {{ entry.billingCode }}
            </v-col>
          </v-row>

          <v-row>
            <v-col :class="`subtitle-2 font-weight-bold ${titleColor}--text`">
              Internal Use Only
            </v-col>
            <v-col class="body-1">
              {{ entry.isAdministrative ? 'TRUE' : 'FALSE' }}
            </v-col>
          </v-row>
        </div>
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn
          text
          color="coolgray"
          @click.stop="cancelAction"
        >
          Cancel
        </v-btn>

        <v-btn
          color="primary"
          @click.stop="submitOrgAction"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card
      v-if="['create', 'update'].includes(action)"
      class="pa-4"
    >
      <v-card-title>
        <span>
          {{ action === 'create' ? 'Add' : 'Edit' }} Organization
        </span>

        <v-card-actions>
          <v-btn
            :ripple="false"
            icon
            @click.stop="close()"
          >
            <v-icon color="brightblue">
              close
            </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card-title>

      <v-card-text class="font-weight-medium">
        <v-row>
          <v-col>
            <v-row>
              <v-col class="pb-0">
                <span :class="`subtitle-2 font-weight-bold ${titleColor}--text`">Identifiers</span>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="pt-0">
                <v-text-field
                  v-model="entry.orgName"
                  class="py-1"
                  dense
                  hide-details
                  label="Client Name"
                  name="clientName"
                  single-line
                />

                <v-text-field
                  v-if="inDevMode"
                  v-model="entry.aliases"
                  class="py-1"
                  dense
                  hide-details
                  label="Aliases"
                  name="aliases"
                  single-line
                />

                <v-text-field
                  v-model="entry.billingCode"
                  class="py-1"
                  dense
                  hide-details
                  label="Billing Code"
                  name="billingCode"
                  single-line
                />

                <v-text-field
                  v-if="inDevMode"
                  v-model="entry.networkCode"
                  class="py-1"
                  dense
                  hide-details
                  label="Network Code"
                  name="networkCode"
                  single-line
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-row>
                  <v-col class="pb-0">
                    <span :class="`subtitle-2 font-weight-bold ${titleColor}--text`">Billing</span>
                  </v-col>
                </v-row>

                <v-row class="mt-0">
                  <v-col class="pb-0">
                    <v-checkbox
                      v-model="entry.isActive"
                      dense
                      label="Active"
                      name="active"
                    />
                  </v-col>
                </v-row>

                <v-row class="mt-0">
                  <v-col class="pt-0">
                    <v-checkbox
                      v-model="entry.isAdministrative"
                      dense
                      label="Internal Use Only"
                      name="isAdministrative"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row
              v-if="inDevMode"
            >
              <v-col class="pt-0">
                <v-row>
                  <v-col class="pb-0">
                    <span :class="`subtitle-2 font-weight-bold ${titleColor}--text`">Contract Dates</span>
                  </v-col>
                </v-row>

                <v-row class="mt-0">
                  <v-col class="pt-0">
                    <v-text-field
                      v-model="entry.startDate"
                      hide-details
                      label="Start Date"
                      name="startDate"
                      single-line
                    />
                  </v-col>

                  <v-col class="pt-0">
                    <v-text-field
                      v-model="entry.endDate"
                      hide-details
                      label="End Date"
                      name="endDate"
                      single-line
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row
              v-if="inDevMode"
              class="mt-4"
            >
              <v-col>
                <v-row>
                  <v-col class="pb-0">
                    <span :class="`subtitle-2 font-weight-bold ${titleColor}--text`">Products & Services</span>
                  </v-col>
                </v-row>

                <v-row class="mt-0">
                  <v-col class="pt-0">
                    <v-combobox
                      v-model="entry.products"
                      hide-details
                      :items="products"
                      label="Products"
                      multiple
                      name="products"
                      single-line
                    />

                    <v-combobox
                      v-model="entry.services"
                      hide-details
                      :items="services"
                      label="Services"
                      multiple
                      name="services"
                      single-line
                    />

                    <v-combobox
                      v-model="entry.reports"
                      hide-details
                      :items="reports"
                      label="Reports"
                      multiple
                      name="reports"
                      single-line
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row
              v-if="inDevMode"
              class="mt-4"
            >
              <v-col>
                <v-row>
                  <v-col class="pb-0">
                    <span :class="`subtitle-2 font-weight-bold ${titleColor}--text`">Address</span>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col class="pt-0">
                    <v-btn
                      color="primary"
                      outlined
                      x-small
                      @click.stop="toggleFormToEditAddress"
                    >
                      <span>Edit Address</span>
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row
                  v-if="showAddressEditor"
                  class="mt-0 px-4"
                >
                  <v-col>
                    <v-row>
                      <v-text-field
                        v-model="addressEditor.careOf"
                        label="Care Of"
                        name="addressCareOf"
                      />
                    </v-row>

                    <v-row>
                      <v-text-field
                        v-model="addressEditor.street"
                        label="Street 1"
                        name="addressStreet"
                      />
                    </v-row>

                    <v-row>
                      <v-text-field
                        v-model="addressEditor.streetExtension"
                        label="Street 2"
                        name="addressExtension"
                      />
                    </v-row>

                    <v-row>
                      <v-text-field
                        v-model="addressEditor.cityName"
                        label="City"
                        name="addressCity"
                      />

                      <v-text-field
                        v-model="addressEditor.stateName"
                        label="State"
                        name="addressState"
                      />

                      <v-text-field
                        v-model="addressEditor.postalCode"
                        label="Postal Code"
                        name="addressPostalCode"
                      />

                      <v-text-field
                        v-model="addressEditor.country"
                        label="Country or Region"
                        name="addressCountry"
                      />
                    </v-row>
                  </v-col>
                </v-row>

                <v-row v-if="entry.address">
                  <v-col>
                    <v-row>
                      <span>{{ entry.address.name }}</span>
                    </v-row>

                    <v-row>
                      <span>{{ entry.address.careOf }}</span>
                    </v-row>

                    <v-row>
                      <span>{{ entry.address.street }}</span>
                    </v-row>

                    <v-row>
                      <span>{{ entry.address.streetExtension }}</span>
                    </v-row>

                    <v-row>
                      <span>{{ entry.address.cityName }}, {{ entry.address.stateNameShort }} {{ entry.address.countryNameShort }}</span>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-card-actions class="justify-end">
              <v-btn
                text
                color="coolgray"
                @click.stop="cancelAction"
              >
                Cancel
              </v-btn>

              <v-btn
                color="primary"
                @click.stop="submitOrgAction"
              >
                Submit
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapGetters: mapAuthGetters } = createNamespacedHelpers('auth')
const { mapGetters: mapLayoutGetters } = createNamespacedHelpers('layout')
const { mapGetters: mapInternalGetters, mapState: mapInternalState } = createNamespacedHelpers('internal')

export default {
  name: 'OrgModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    addressEditor: {},
    loading: false,
    showAddressEditor: false,

    products: [
      'AdJuster',
      'AdWallet',
      'EAC',
      'FatTail',
      'Google Ad Manager 360',
      'Google AdSense',
      'Google AdX',
      'Google Campaign Manager',
      'Magnite Demand Manager',
    ],
    services: [
      'AM360',
      'FatTail',
      'Burt',
      'AdWallet',
      'Audigent',
      'SpringServe',
      'Data Transfer',
      'Ad Sales',
      'Direct',
      'AdX',
      'MDM',
      'Support',
      'Ad Product',
      'BTS',
      'OAOAV',
      'EAC',
      'Custom Analytics',
    ],
    reports: [
      'AdX & OB',
      'AdX Health',
      'Discrepancy',
      'Network Health',
      'Pacing',
    ],
  }),
  computed: {
    visible: {
      get() {
        return this.isOrganizationModalVisible
      },
      set(value) {
        this.$store.commit('internal/isOrganizationModalVisible', value)
      },
    },
    ...mapAuthGetters([
      'inDevMode',
    ]),
    ...mapLayoutGetters([
      'titleColor',
    ]),
    ...mapInternalGetters(['errorMessage', 'successMessage']),
    ...mapInternalState({
      action: (state) => state.action,
      entry: (state) => state.entry,
      didLoadOrganizationFail: (state) => state.didLoadOrganizationFail,
      isLoadingOrganization: (state) => state.isLoadingOrganization,
      isOrganizationModalVisible: (state) => state.isOrganizationModalVisible,
      organization: (state) => state.organization,
      organizations: (state) => state.organizations,
      selected: (state) => state.selected,
    }),
    viewOrganization() {
      const {
        organizations,
        didLoadOrganizationFail,
        isLoadingOrganization,
      } = this

      return isLoadingOrganization === false
        && didLoadOrganizationFail === false
        && organizations.length > 0
    },
    noOrganizationData() {
      const {
        organizations,
        isLoadingOrganization,
        didLoadOrganizationFail,
      } = this
      const requestComplete = isLoadingOrganization === false
      const requestSucceeded = didLoadOrganizationFail === false
      const noResults = organizations.length === 0

      return requestComplete && requestSucceeded && noResults
    },
  },
  watch: {
    selected(newValue) {
      if (newValue) {
        // do something
      }
    },
  },
  methods: {
    close() {
      this.$store.commit('internal/isOrganizationModalVisible', false)
    },

    toggleFormToCreateAddress() {
      this.addressEditor = {}
      this.showAddressEditor = true
    },
    toggleFormToEditAddress() {
      // Toggle the form to edit the address.
      if (this.showAddressEditor) {
        this.showAddressEditor = false
        this.addressEditor = {}
      } else {
        this.addressEditor = this.entry.address || {}
        this.showAddressEditor = true
      }
    },
    createAddress() {
      // Add the address to the entry's addresses array.
      this.showAddressEditor = false
    },
    updateAddress() {
      // Update the address in the entry's addresses array.
      this.showAddressEditor = false
    },
    softDeleteAddressConfirm() {
      this.confirmSoftDeleteOfAddress = true
    },
    hardDeleteAddressConfirm() {
      this.confirmHardDeleteOfAddress = true
    },
    softDeleteAddress() {
      this.confirmSoftDeleteOfAddress = false
    },
    hardDeleteAddress() {
      this.confirmHardDeleteOfAddress = false
    },

    async submitOrgAction() {
      const { action, entry } = this
      const { commit, dispatch } = this.$store
      // @TODO: Actually map the action to what it's meant to be.
      const map = {
        create: 'ADD',
        update: 'UPDATE',
        delete: 'DELETE',
      }

      entry.action_type = map[action]

      const response = await dispatch('internal/submitOrgAction', entry)
      const { content = [], error } = response || {}

      if (error || content?.code || !response) {
        const message = error?.message || content?.message || content?.code || 'Unknown API Error'

        commit('tools/snackbar', true)
        commit('tools/snack', { message, status: 'error' })

        return error || content
      }

      const [entryId] = content
      const status = entryId ? 'success' : 'error'
      const message = entryId ? this.successMessage : this.errorMessage

      if (status === 'success') {
        this.close()
      }

      commit('tools/snackbar', true)
      commit('tools/snack', { message, status })

      return response
    },
    cancelAction() {
      const { selected } = this

      this.$store.commit('internal/action', 'read')
      this.$store.commit('internal/entry', Object.create(selected))

      this.close()
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~src/styles/variables";

::v-deep.v-card {
  border-radius: 6px;
  border-width: 0;
}

::v-deep.v-card__title {
  color: $color-monochrome-darkestblue;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.51px;
  line-height: 22px;
  justify-content: space-between;
}

::v-deep.v-card__text {
  padding: 0;
}

.v-card + .v-card {
  margin-top: 1ch;
}
</style>
